/**
 * Clients Page
 */

import React, { useState } from 'react';
import { useClientStore } from '../store/clientStore';
import { useDataSubscriptions } from '../hooks/useDataSubscriptions';
import ClientList from '../components/ClientList';
import ClientModal from '../components/ClientModal';
import OnboardClientModal from '../components/OnboardClientModal';

const Clients = () => {
  useDataSubscriptions();

  const clients = useClientStore((state) => state.clients);
  const deleteClient = useClientStore((state) => state.deleteClient);

  const [showModal, setShowModal] = useState(false);
  const [showOnboard, setShowOnboard] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('clientsViewMode') || 'grid');

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
    localStorage.setItem('clientsViewMode', mode);
  };

  const handleAdd = () => {
    setEditingClient(null);
    setShowModal(true);
  };

  const handleEdit = (client) => {
    setEditingClient(client);
    setShowModal(true);
  };

  const handleDelete = async (clientId) => {
    if (!window.confirm('Are you sure you want to delete this client?')) {
      return;
    }

    try {
      await deleteClient(clientId);
    } catch (error) {
      alert('Error deleting client: ' + error.message);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingClient(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1>Clients</h1>
          <p style={{ color: 'var(--text-secondary)', margin: '0.5rem 0 0 0' }}>
            Manage your client information and default rates
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          <div className="view-toggle">
            <button
              className={`view-toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('grid')}
              title="Grid view"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
              </svg>
            </button>
            <button
              className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('list')}
              title="List view"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
          </div>
          <button className="btn btn-secondary" onClick={handleAdd}>
            + Add Client
          </button>
          <button className="btn btn-primary" onClick={() => setShowOnboard(true)}>
            ⚡ Onboard Client
          </button>
        </div>
      </div>

      <ClientList
        clients={clients}
        onEdit={handleEdit}
        onDelete={handleDelete}
        viewMode={viewMode}
      />

      {showModal && (
        <ClientModal
          client={editingClient}
          onClose={handleCloseModal}
        />
      )}

      {showOnboard && (
        <OnboardClientModal
          onClose={() => setShowOnboard(false)}
        />
      )}
    </div>
  );
};

export default Clients;
